import { CommandParser } from '@redis/client/dist/lib/client/parser';
import { RedisArgument, SimpleStringReply, Command } from '@redis/client/dist/lib/RESP/types';

export default {
  parseCommand(parser: CommandParser, sourceKey: RedisArgument, destinationKey: RedisArgument) {
    parser.push('TS.DELETERULE');
    parser.pushKeys([sourceKey, destinationKey]);
  },
  transformReply: undefined as unknown as () => SimpleStringReply<'OK'>
} as const satisfies Command;
